import React from "react";
import { GET, POST, PUT } from "Common/api";
import Dialog from "Components/Fragment/Dialog";
import { Button } from "Components/Base/Inputs/Button";
import AddInternal from "./addinternal.jsx";
import AddExternal from "./addexternal.jsx";
import AddOtherActivity from "./addotheractivity.jsx";
import Notifier from "lib/components/notifier";
import LuvitComponent from "LuvitComponent";
import config from "lib/config";
import SettingStore from "stores/settings";
import { hasRight } from "lib/rightsmanager.js";
import styled from "styled-components";
import { observer } from "mobx-react";
import OptionButtons from "Components/Fragment/OptionButtons";
import { ChevronRight, HomeIcon, OpenInNewIcon } from "Components/Icons";
import {
  ID_COURSE_CATALOGUE,
  ID_COURSE_CATALOGUE_CARDVIEW,
} from "lib/constants/mainmenu";

var pId = config.personalId;

const StyledActivityEdit = styled.div`
  label {
    font-weight: 700;
    display: block;
    font-size: unset;
  }
`;

@observer
export default class AddActivity extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "TalentManagement");

    this.save = this.save.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.setType = this.setType.bind(this);
    this.hideBack = this.hideBack.bind(this);
    this.state = {
      open: true,
      displayOverview: true,
    };
  }

  async componentWillMount() {
    let isManager = false;
    const { personalId } = this.props;

    if (personalId !== pId) {
      isManager = true;
    } else {
      isManager = !!this.props.isManager;
    }

    let personalName = await GET("/v1/users/name/:personalId", {
      personalId,
    });

    let allowUsersToCompleteCourses = SettingStore.getSettingValue(
      "allowusertocompletecourses",
    );

    let allowUsersToCompleteActivities = SettingStore.getSettingValue(
      "allowusertocompleteactivities",
    );

    let hideOtherActivitiesInEducationHistory = SettingStore.getSettingValue(
      "hideotheractivitiesineducationhistory",
    );

    const hideAddCompletedCoursesInEducationHistory =
      SettingStore.getSettingValue("hideaddcompletedcoursesineducationhistory");

    const {
      enableExternalLMS,
      externalCourseTypeTitle,
      externalLMSUrl,
      externalLMSLinkTarget,
    } = this.getExternalLMSSettings();

    const hasAccessToCourseCatalogue =
      (await hasRight(ID_COURSE_CATALOGUE)) ||
      (await hasRight(ID_COURSE_CATALOGUE_CARDVIEW));
    let type =
      !hasAccessToCourseCatalogue && !enableExternalLMS
        ? "otheractivity"
        : this.props.type || "";

    this.setState({
      ready: true,
      type,
      errors: {},
      allowUsersToCompleteCourses,
      allowUsersToCompleteActivities,
      hideOtherActivitiesInEducationHistory,
      hideAddCompletedCoursesInEducationHistory,
      isManager,
      personalName,
      hideBack: !hasAccessToCourseCatalogue,
      hasAccessToCourseCatalogue,
      enableExternalLMS,
      externalCourseTypeTitle,
      externalLMSUrl,
      externalLMSLinkTarget,
    });
  }

  setType(type) {
    return (() => {
      this.setState({ type: type });
    }).bind(this);
  }

  onRefresh() {
    this.props.onRefresh();
  }

  onCancelAddActivity() {
    this.refs.modal && this.refs.modal.close();
  }

  componentWillReceiveProps(newProps) {
    this.refs &&
      this.refs.modal &&
      this.refs.modal.show &&
      this.refs.modal.show();

    if (this.props.activity != newProps.activity) this.setState({ errors: {} });
  }

  save(data, files, registration, approvalRequestCallback = null) {
    let act = this.props.activity;
    if (data.personalPlannedCourseId !== undefined && !act.id) {
      act.id = data.personalPlannedCourseId;
    }
    let toSave = {
      Id: act.id === true ? null : act.id,
      personalGoalId: act.personalGoalId,
      ...data,
    };

    const pId =
      this.props.personalId || luvit.GetQueryString("id") || config.pId;

    if (pId) toSave.personalId = pId;

    const formData = new FormData();
    for (let key in toSave) {
      formData.append(key, toSave[key]);
    }

    let uploadedFiles = files || [];

    uploadedFiles.forEach((file) => {
      formData.append(file.name, file);
    });

    let req;
    if (this.props.fromEducationHistory) {
      if (act.id && act.id !== true)
        req = PUT("/v1/coworker/externalcourse/", {}, formData, false);
      else req = POST("/v1/coworker/externalcourse/", {}, formData, false);
    } else {
      if (act.id && act.id !== true)
        req = PUT("/v1/coworkeractivity/", {}, formData, false);
      else req = POST("/v1/coworkeractivity/", {}, formData, false);
    }

    let busy = req;

    busy.then(async (res) => {
      if (res == null) {
        return busy;
      }
      //Error
      if (res < 0) {
        this.handleSaveError();
      } else {
        const savedData = res > 0 ? { ...toSave, Id: res } : toSave;
        if (typeof this.props.onActivitySaved === "function") {
          this.props.onActivitySaved(savedData);
        }
        //New activity
        if (res > 0) {
          if (approvalRequestCallback) {
            await approvalRequestCallback(res);
          }
          if (typeof this.props.onRefresh === "function") {
            this.props.onRefresh();
          }
          this.props.onShowSaveNotification(
            this.l("success"),
            this.l("theactivityisnowavailableinthelist"),
          );
        }
        //Updating activity
        if (res == 0 && act.id) {
          if (approvalRequestCallback) {
            await approvalRequestCallback(act.id);
          }
          if (typeof this.props.onRefresh === "function") {
            this.props.onRefresh();
          }
          this.props.onShowSaveNotification(
            this.l("success"),
            this.l("theactivitywasupdated"),
          );
        }
        if (!registration) {
          this.onModalClose();
          this.onCancelAddActivity();
        }
      }
    });

    return busy;
  }

  handleSaveError = () => {
    if (res === -1) {
      this.setState({ error: "extnotallowed" });
    } else if (res === -2) {
      this.setState({ error: "erremptyfile" });
    } else if (res === -3) {
      this.setState({ error: "fileSizeTooLarge" });
    } else {
      this.setState({ error: "infUploadErr" });
    }
  };

  onModalClose() {
    this.setState({ open: false });
    this.props.resetEditActivity();

    if (this.props.refreshOnClose) {
      if (typeof this.props.onRefresh === "function") {
        this.props.onRefresh();
      }
    }
  }

  hideBack(val) {
    this.setState({ hideBack: val });
  }

  showSaveNotification(title, text) {
    this.refs.notificator.success(title, text, 30000);
  }

  showErrorNotification(title, text) {
    this.refs.notificator.error(title, text, 30000);
  }

  getExternalLMSSettings = () => {
    const enableExternalLMS =
      SettingStore.getSettingValue("EnableExternalLMS") === "1";
    const externalCourseTypeTitle = SettingStore.getSettingValue(
      "ExternalCourseTypeTitle",
    );
    const externalLMSUrl = SettingStore.getSettingValue("ExternalLMSUrl");
    const externalLMSLinkTarget = SettingStore.getSettingValue(
      "ExternalLmsLinkTarget",
    );

    return {
      enableExternalLMS,
      externalCourseTypeTitle,
      externalLMSUrl,
      externalLMSLinkTarget,
    };
  };

  hideOtherActivity = (PERMISSION) => {
    const HIDDEN = "1";
    return (
      this.props.fromEducationHistory &&
      ((this.state.allowUsersToCompleteActivities === PERMISSION.DISALLOWED &&
        !this.state.isManager) ||
        this.state.hideOtherActivitiesInEducationHistory === HIDDEN)
    );
  };

  hideExternalCourse = (PERMISSION) => {
    const HIDDEN = "1";
    return (
      this.props.fromEducationHistory &&
      ((this.state.allowUsersToCompleteCourses === PERMISSION.DISALLOWED &&
        !this.state.isManager) ||
        this.state.hideAddCompletedCoursesInEducationHistory === HIDDEN)
    );
  };

  renderOptions = () => {
    const PERMISSION = { ALLOWED: "1", DISALLOWED: "0" };
    const showAddOtherActivity = !this.hideOtherActivity(PERMISSION);
    const showAddExternalCourse = !this.hideExternalCourse(PERMISSION);
    const {
      enableExternalLMS,
      externalCourseTypeTitle,
      externalLMSUrl,
      externalLMSLinkTarget,
      hasAccessToCourseCatalogue,
    } = this.state;

    const showExternalLMS =
      enableExternalLMS && !this.props.fromEducationHistory;
    const showCourseCatalogue =
      hasAccessToCourseCatalogue && !this.props.fromEducationHistory;

    return [
      showExternalLMS && {
        title: externalCourseTypeTitle,
        description: this.l("addexternalactivitydescription").replace(
          "%type%",
          externalCourseTypeTitle,
        ),
        icon: <OpenInNewIcon />,
        onClick: () =>
          window.open(
            externalLMSUrl,
            externalLMSLinkTarget === "1" ? "_parent" : "_blank",
          ),
      },
      showCourseCatalogue && {
        title: this.l("coursecatalogue"),
        description: this.l("addinternalfromcoursecatalogue"),
        icon: <HomeIcon />,
        onClick: this.setType("internalcourse"),
      },
      showAddExternalCourse && {
        title: this.l("externalcourse"),
        description: this.l("addexternalcourse"),
        icon: <OpenInNewIcon />,
        onClick: this.setType("externalcourse"),
      },
      showAddOtherActivity && {
        title: this.l("otheractivity"),
        description: this.l("addOtherTraining"),
        icon: <ChevronRight />,
        onClick: this.setType("otheractivity"),
      },
    ];
  };

  getType = (selectedActivityType) => {
    const lowerCaseSelectedActivityType = selectedActivityType.toLowerCase();
    switch (lowerCaseSelectedActivityType) {
      case "externalcourse":
        return AddExternal;
      case "otheractivity":
      case "commonactivity":
      case "programotheractivity":
      case "programcommonactivity":
        return AddOtherActivity;
      default:
        return AddInternal;
    }
  };

  getIsProgramCommonActivity = (selectedActivityType) => {
    const lowerCaseSelectedActivityType = selectedActivityType.toLowerCase();
    switch (lowerCaseSelectedActivityType) {
      case "programotheractivity":
      case "programcommonactivity":
        return true;
      default:
        return false;
    }
  };

  doRender() {
    if (!this.state || !this.state.ready) return <div />;

    let act = this.props.activity;
    if (!act || !this.state.open) return <div />;

    let selectedActivityType =
      act.type ||
      (this.state.type == "internalcourse"
        ? "fromcoursecatalogue"
        : this.state.type);

    let addCompletedModalHeader = this.l("addcompletedactivity");
    let addActivityModalHeader = this.l("addactivity");

    if (selectedActivityType) {
      addCompletedModalHeader += " - " + this.l(selectedActivityType);
      addActivityModalHeader += " - " + this.l(selectedActivityType);
    }

    const Type = this.getType(selectedActivityType);
    const isProgramCommonActivity =
      this.getIsProgramCommonActivity(selectedActivityType);

    const getDialogTitle = () => {
      if (act.id) {
        return this.props.fromCompetenceProfile
          ? this.l("addactivitytocompetenceplan")
          : this.l("editactivity2");
      }
      return this.props.fromEducationHistory
        ? addCompletedModalHeader
        : addActivityModalHeader;
    };

    const dialogTitle = getDialogTitle();

    return (
      <Dialog
        title={dialogTitle}
        open={this.state.open}
        maxWidth="md"
        fullWidth={true}
        onClose={this.onModalClose}
        closeTitle={this.l("close")}
        cancelText={!selectedActivityType ? this.l("cancel") : null}
        text={
          <>
            <Notifier ref="notificator" hideHeader={false} />
            {!selectedActivityType && (
              <OptionButtons
                options={this.renderOptions()}
                addCircleIconStyle
              />
            )}
            {selectedActivityType && (
              <>
                <StyledActivityEdit className="activity-edit animated fadeInDown">
                  {!act.id && !this.state.hideBack && (
                    <div className="flex flex-end">
                      <Button
                        variant="text"
                        onClick={this.setType("")}
                        label={this.l("back")}
                      />
                    </div>
                  )}
                  <Type
                    fromEducationHistory={!!this.props.fromEducationHistory}
                    fromProgramPage={this.props.fromProgramPage || false}
                    allowAttachment={this.props.allowAttachment}
                    allowUsersToCompleteCourses={
                      this.state.allowUsersToCompleteCourses
                    }
                    allowUsersToCompleteActivities={
                      this.state.allowUsersToCompleteActivities
                    }
                    isManager={this.state.isManager}
                    onCancel={() => this.onModalClose()}
                    onRefresh={this.onRefresh.bind(this)}
                    activity={act}
                    personalId={this.props.personalId}
                    save={this.save.bind(this)}
                    hideBack={this.hideBack}
                    personalName={this.state.personalName}
                    error={this.state.error}
                    isProgramCommonActivity={isProgramCommonActivity}
                    showSaveNotification={this.showSaveNotification.bind(this)}
                    showErrorNotification={this.showErrorNotification.bind(
                      this,
                    )}
                  />
                </StyledActivityEdit>
              </>
            )}
          </>
        }
      />
    );
  }
}
